module.exports = __webpack_public_path__ + "img/pdf_footer03.9344de8a.jpg";